var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('div',{staticClass:"py-10 flex items-center justify-center"},[_c('button',{staticClass:"px-10 py-2 rounded bg-blue-500 text-white",on:{"click":function($event){return _vm.setSlideoverWrapper({
					current: true,
					related_id: null,
				})}}},[_vm._v(" Create ")])]),_c('intro',{staticClass:"w-full"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }